import { useEffect } from "react";

export default ({ props }: any) => {
  useEffect(() => {
    if (
      props.submitCount < 1 ||
      !props.errors ||
      Object.keys(props.errors).length === 0
    ) {
      return;
    }
    const element = document.querySelectorAll("[aria-invalid=true]")?.[0];
    if (!element) return;
    element?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    if (element instanceof HTMLElement) {
      element.focus();
    }
  }, [props.submitCount, props.errors]);
  return null;
};
